module.exports = __webpack_public_path__ + "static/media/newAwards.93e6bdca.png";